"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;
exports.resetInitFlag = resetInitFlag;
var _events = require("@ori/events");
var _initGlobalAnalyticEvents = require("./deprecated/initGlobalAnalyticEvents");
var _initShoppingContextEvents = require("./deprecated/initShoppingContextEvents");
var _logger = require("./logger");
var _tagManagement = require("./tag-management");
const logger = _logger.mainLogger.createChild('init');
let isInitialized = false;

// Main initialization.
function init(config) {
  if (isInitialized) {
    return;
  }
  const tagManagementHandler = (0, _tagManagement.setupTagManagementSystems)(config);
  isInitialized = true;

  // Handle new integration events
  window.addEventListener(_events.INTEGRATION_EVENT_NAME, event => {
    const {
      name,
      ...data
    } = event.detail;
    tagManagementHandler(name, data);
  });

  // Connect old integration event listeners. Once these are using @ori/events, we can remove this as their sending will go through the above listener.
  (0, _initGlobalAnalyticEvents.initGlobalAnalyticEvents)(tagManagementHandler);
  (0, _initShoppingContextEvents.initShoppingContextEvents)(tagManagementHandler);

  // Set ready flag in globals for other components with critical initialization timing.
  window.isAnalyticsProviderReady = true;
  logger.info('Analytics provider initialized', {
    config: JSON.stringify(config, null, 2)
  });
}

// This helper is used just for testing ATM.
function resetInitFlag() {
  isInitialized = false;
}